<template>
  <div>
    <b-row>
      <b-col cols="10" sm="7" md="2" lg="2" class="my-2">
        <span class="mr-3 h5">Matrícula en línea</span>
      </b-col>
      <b-col v-if="hasChildren" cols="10" sm="7" md="4" lg="4" class="p-auto">
        <b-form-group id="input-group-2">
          <b-form-select v-model="selectedChild" :options="children"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-card no-body class="mt-3 mb-auto" v-if="isRoleValid.includes(consts.rolesText.ESTUDIANTE) && this.step >= consts.ENROLLMENT_STEP.DATA">
      <b-row>
        <b-col cols="10" sm="10" md="10" lg="11" class="p-auto">
          <b-button block v-b-toggle="'collapsableStudent'" variant="link" class="m-auto text-left">
            <!-- <i v-bind:class="[formComplete[0] ? 'fa fa-check-square' : 'fa fa-square-o']" /> -->
            <i class="fa fa-square-o" />
            Información del estudiante
          </b-button>
        </b-col>
        <b-col cols="1" sm="1" md="1" lg="1" class="p-0">
          <b-button block v-b-toggle="'collapsableStudent'" variant="link" class="m-auto text-left">
            <i :class=" collapsableStudent ? 'fa fa-angle-double-up text-right' : 'fa fa-angle-double-down text-right'" />
          </b-button>
        </b-col>
      </b-row>
      <b-collapse
        :id="'collapsableStudent'"
        :accordion="'infoStudent'"
        role="tabpanel"
        v-model="collapsableStudent"
        class="mt-2"
        style="overflow-y:scroll;"
      >
      <!-- Información estudiante -->
        <div class="container-fluid" style="height:380px;" v-if="collapsableStudent">
          <div class="row">
            <div class="col-sm-12">
              <validation-observer ref="observer1" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(savePersonalInfo(0))">
                  <div class="row" id="s1">
                    <div class="col-md-12">
                      <validation-provider
                        name="Nacionalidad"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student1" label="Nacionalidad:" label-for="input-student1"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student1" v-model="formPersonalInfo[0].nationality" required placeholder="Ingrese nacionalidad" :state="getValidationState(validationContext)" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s2">
                    <div class="col-md-12">
                      <validation-provider
                        name="Lugar de nacimiento"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student2" label="Lugar de Nacimiento:" label-for="input-student2"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student2" v-model="formPersonalInfo[0].birthplace" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese ciudad de nacimiento" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s3">
                    <div class="col-md-12">
                      <validation-provider
                        name="Sexo"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student3" label="Sexo:" label-for="input-student3" :invalid-feedback="validationContext.errors[0]" >
                          <b-form-select id="input-student3" v-model="formPersonalInfo[0].gender" :options="genderOptions" required
                          :state="getValidationState(validationContext)" :disabled="disabledField"></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="sp" v-if="formPersonalInfo[4].phone !== undefined">
                    <div class="col-md-12">
                      <validation-provider
                        name="Télefono personal"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-studentPhone" label="Télefono personal:" label-for="input-studentPhone"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-studentPhone" v-model="formPersonalInfo[4].phone" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el número telefónico" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s4">
                    <div class="col-md-12">
                      <validation-provider
                        name="Fecha de nacimiento"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student4" label="Fecha de nacimiento:"
                        label-for="input-student4" :invalid-feedback="validationContext.errors[0]">
                          <b-form-datepicker
                            id="input-student4"
                            v-model="formPersonalInfo[0].birthday"
                            type="date"
                            placeholder="Seleecione fecha de nacimiento"
                            style="width: 100%"
                            required
                            :state="getValidationState(validationContext)"
                            :disabled="disabledField"
                          ></b-form-datepicker>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s5">
                    <div class="col-md-12">
                      <validation-provider
                        name="Tipo de identificación"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student5" label="Tipo de identificación:"
                        label-for="input-student5" :invalid-feedback="validationContext.errors[0]">
                          <b-form-select id="input-student5" v-model="formPersonalInfo[0].idType" :options="documentOptions"
                          required :state="getValidationState(validationContext)"
                           :disabled="disabledField"
                          ></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s6">
                    <div class="col-md-12">
                      <validation-provider
                        name="Ciudad de expedición"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student6" label="Ciudad de expedición del documento de identidad:" label-for="input-student6"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student6" v-model="formPersonalInfo[0].expeditionPlace" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese ciudad de expedición" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s7">
                    <div class="col-md-12">
                      <validation-provider
                        name="Grupo sanguíneo"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student7" label="Grupo sanguíneo:"
                        label-for="input-student7" :invalid-feedback="validationContext.errors[0]">
                          <b-form-select id="input-student7" v-model="formPersonalInfo[0].bloodType" :options="bloodOptions"
                          required :state="getValidationState(validationContext)" :disabled="disabledField"></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s8">
                    <div class="col-md-12">
                      <validation-provider
                        name="EPS"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student8" label="Entidad promotora de salud EPS:" label-for="input-student8"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student8" v-model="formPersonalInfo[0].eps" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el nombre de la EPS" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s9">
                    <div class="col-md-12">
                      <validation-provider
                        name="Altura"
                        :rules="{ required: true, numeric: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student9" label="Altura (cm):" label-for="input-student9"
                        invalid-feedback="El campo Altura debe contener solo valores numéricos">
                          <b-form-input id="input-student9" v-model="formPersonalInfo[0].height" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese altura en cm del estudiante" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s10">
                    <div class="col-md-12">
                      <validation-provider
                        name="Masa corporal"
                        :rules="{ required: true, numeric: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student10" label="Masa corporal (g):" label-for="input-student10"
                        invalid-feedback="El campo Masa corporal debe contener solo valores numéricos">
                          <b-form-input id="input-student10" v-model="formPersonalInfo[0].mass" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la masa corporal del estudiante" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s11">
                    <div class="col-md-12">
                      <validation-provider
                        name="Dirección residencia"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student11" label="Dirección residencia:" label-for="input-student11"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student11" v-model="formPersonalInfo[0].address" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese dirección de residencia" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s12">
                    <div class="col-md-12">
                      <validation-provider
                        name="Barrio"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student12" label="Barrio:" label-for="input-student12"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student12" v-model="formPersonalInfo[0].neighborhood" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese barrio de residencia" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s13">
                    <div class="col-md-12">
                      <validation-provider
                        name="Ciudad"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student13" label="Ciudad:" label-for="input-student13"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student13" v-model="formPersonalInfo[0].city" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese ciudad de residencia" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s14">
                    <div class="col-md-12">
                      <validation-provider
                        name="Estrato"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student14" label="Estrato:" label-for="input-student14"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student14" v-model="formPersonalInfo[0].stratum" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese estrato socioeconómico" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s15">
                    <div class="col-md-12">
                      <validation-provider
                        name="Número de Hermanos"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student15" label="Número de Hermanos:" label-for="input-student15"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student15" v-model="formPersonalInfo[0].numberBrother" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el número de hermanos" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s16">
                    <div class="col-md-12">
                      <validation-provider
                        name="¿Con quién permanece más tiempo?"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student16" label="¿Con quién permanece más tiempo?:" label-for="input-student16"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student16" v-model="formPersonalInfo[0].stayWithTheLongest" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la información requerida" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s17">
                    <div class="col-md-12">
                      <validation-provider
                        name="Historia clínica"
                        :rules="{ required: false }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student17" label="Historia clínica(alergias, cirugias, entre otras):" label-for="input-student17"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student17" v-model="formPersonalInfo[0].clinicHistory"
                          :state="getValidationState(validationContext)" placeholder="Ingrese información requerida" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s18">
                    <div class="col-md-12">
                      <validation-provider
                        name="Observaciones"
                        :rules="{ required: false }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student18" label="Observaciones:" label-for="input-student18"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-student18" v-model="formPersonalInfo[0].observations"
                          :state="getValidationState(validationContext)" placeholder="Ingrese observaciones relacionadas con el estudiante" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s19">
                    <div class="col-md-12">
                      <validation-provider
                        name="Área de estudio"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student19" label="Área de estudio preferida:" label-for="input-student19"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-select id="input-student19" v-model="formPersonalInfo[0].preferredArea" :options="areaOptions"
                          :state="getValidationState(validationContext)" required :disabled="disabledField"></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s20">
                    <div class="col-md-12">
                      <validation-provider
                        name="Área con mayor dificultad"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student20" label="Área de estudio con mayor dificultad:"
                        :invalid-feedback="validationContext.errors[0]" label-for="input-student20">
                          <b-form-select id="input-student20" v-model="formPersonalInfo[0].areaGreatestDifficulty" :options="areaOptions"
                          :state="getValidationState(validationContext)" required :disabled="disabledField"></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="s21">
                    <div class="col-md-12">
                      <validation-provider
                        name="Estado civil"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-student21" label="Estado civil de los padres:" label-for="input-student21"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-select id="input-student21" v-model="formPersonalInfo[0].maritalStatus" :options="maritalOptions"
                          :state="getValidationState(validationContext)" required :disabled="disabledField"></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar cambios</b-button>
                </b-form>
              </validation-observer>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-auto" v-show="formOptionsToFill.momLives === 'SI' && isRoleValid.includes(consts.rolesText.PADRE_MADRE) && isMother && this.step >= consts.ENROLLMENT_STEP.DATA">
      <b-row>
        <b-col cols="10" sm="10" md="10" lg="11" class="p-auto">
          <b-button block v-b-toggle="'collapsableMother'" variant="link" class="m-auto text-left">
            <!-- <i v-bind:class="[formComplete[1] ? 'fa fa-check-square' : 'fa fa-square-o']" /> -->
            <i class="fa fa-square-o" />
            Información de la madre
          </b-button>
        </b-col>
        <b-col cols="1" sm="1" md="1" lg="1" class="p-0">
          <b-button block v-b-toggle="'collapsableMother'" variant="link" class="m-auto text-left">
            <i :class=" collapsableMother ? 'fa fa-angle-double-up text-right' : 'fa fa-angle-double-down text-right'" />
          </b-button>
        </b-col>
      </b-row>
      <b-collapse
        :id="'collapsableMother'"
        :accordion="'infoStudent'"
        role="tabpanel"
        v-model="collapsableMother"
        style="overflow-y:scroll;"
      >
      <!-- Información madre -->
        <div class="container-fluid" style="height:380px;" v-if="collapsableMother">
          <div class="row">
            <div class="col-sm-12">
              <validation-observer ref="observer2" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(savePersonalInfo(1))">
                  <div class="row" id="m13">
                    <div class="col-md-12">
                      <validation-provider
                        name="Tipo de documento"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother13" label="Tipo de documento:" label-for="input-mother13" :invalid-feedback="validationContext.errors[0]" >
                          <b-form-select id="input-mother13" v-model="formPersonalInfo[1].momTypeDocument" :options="documentFatherMotherOptions" required
                          :state="getValidationState(validationContext)" :disabled="disabledField"></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m14" v-if="['CC', 'TI'].includes(formPersonalInfo[1].momTypeDocument)">
                    <div class="col-md-12">
                      <validation-provider
                        name="Fecha de expedición del documento"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother14" label="Fecha de expedición del documento:"
                        label-for="input-mother14" :invalid-feedback="validationContext.errors[1]">
                          <b-form-datepicker
                            id="input-mother14"
                            v-model="formPersonalInfo[1].momDocumentIssueDate"
                            type="date"
                            placeholder="Seleecione la fecha de expedición del documento"
                            style="width: 100%"
                            required
                            :state="getValidationState(validationContext)"
                           :disabled="disabledField"
                          ></b-form-datepicker>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m4" v-if="['CC', 'TI'].includes(formPersonalInfo[1].momTypeDocument)">
                    <div class="col-md-12">
                      <validation-provider
                        name="Ciudad de expedición"
                        :rules="{ required: true, alpha_spaces: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother4" label="Identificación expedida en:" label-for="input-mother4"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-mother4" v-model="formPersonalInfo[1].momExpeditionPlace" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la ciudad de expedición del documento" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m5">
                    <div class="col-md-12">
                      <validation-provider
                        name="Correo electrónico"
                        :rules="{ required: true, email: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother5" label="Correo electrónico:" label-for="input-mother5"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-mother5" v-model="formPersonalInfo[1].momEmail" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el correo electrónico" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m6">
                    <div class="col-md-12">
                      <validation-provider
                        name="Dirección"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother6" label="Dirección:" label-for="input-mother6"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-mother6" v-model="formPersonalInfo[1].momAddress" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la dirección de residencia de la Madre" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m7">
                    <div class="col-md-12">
                      <validation-provider
                        name="Ciudad"
                        :rules="{ required: true, alpha_spaces: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother7" label="Ciudad:" label-for="input-mother7"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-mother7" v-model="formPersonalInfo[1].momCity" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la ciudad de residencia de la Madre" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m8">
                    <div class="col-md-12">
                      <validation-provider
                        name="Télefono personal"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother8" label="Télefono personal:" label-for="input-mother8"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-mother8" v-model="formPersonalInfo[1].momPhone" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el número telefónico" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m9">
                    <div class="col-md-12">
                      <validation-provider
                        name="Ocupación"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother9" label="Ocupación:" label-for="input-mother9"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-mother9" v-model="formPersonalInfo[1].momOcupation" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la ocupación de la madre" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m10">
                    <div class="col-md-12">
                      <validation-provider
                        name="Trabaja como"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother10" label="Trabaja como:" label-for="input-mother10" :invalid-feedback="validationContext.errors[0]" >
                          <b-form-select id="input-mother10" v-model="formPersonalInfo[1].momWorkAs" :options="workAsOptions" required
                          :state="getValidationState(validationContext)" :disabled="disabledField"></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m11">
                    <div class="col-md-12">
                      <validation-provider
                        name="Nombre de la empresa"
                        :rules="rulesWorkAs(1)"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother11" label="Nombre de la empresa donde trabaja:" label-for="input-mother11"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-mother11" v-model="formPersonalInfo[1].momCompany" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el nombre de la empresa donde trabaja" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m12">
                    <div class="col-md-12">
                      <validation-provider
                        name="Teléfono de la empresa"
                        :rules="rulesWorkAs(1)"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-mother12" label="Teléfono de la empresa:" label-for="input-mother12"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-mother12" v-model="formPersonalInfo[1].momCompanyPhone" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el teléfono de contacto en la empresa" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="m15">
                    <div class="col-md-12">
                        <b-form-group id="input-group-mother15">
                          <b-form-checkbox v-model="publishAllowed" :disabled="formPersonalInfo[4].publishAllowed">
                            Autorizo el uso de la imagen de mi hijo para temas publicitarios del colegio*
                          </b-form-checkbox>
                          <small class="ml-4">*Este campo es opcional</small>
                        </b-form-group>
                    </div>
                  </div>
                  <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar cambios</b-button>
                </b-form>
              </validation-observer>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-auto" v-show="formOptionsToFill.dadLives === 'SI' && isRoleValid.includes(consts.rolesText.PADRE_MADRE) && isFather && this.step >= consts.ENROLLMENT_STEP.DATA">
      <b-row>
        <b-col cols="10" sm="10" md="10" lg="11" class="p-auto">
          <b-button block v-b-toggle="'collapsableFather'" variant="link" class="m-auto text-left">
            <!-- <i v-bind:class="[formComplete[2] ? 'fa fa-check-square' : 'fa fa-square-o']" /> -->
            <i class="fa fa-square-o" />
            Información del padre
          </b-button>
        </b-col>
        <b-col cols="1" sm="1" md="1" lg="1" class="p-0">
          <b-button block v-b-toggle="'collapsableFather'" variant="link" class="m-auto text-left">
            <i :class=" collapsableFather ? 'fa fa-angle-double-up text-right' : 'fa fa-angle-double-down text-right'" />
          </b-button>
        </b-col>
      </b-row>
      <b-collapse
        :id="'collapsableFather'"
        :accordion="'infoStudent'"
        role="tabpanel"
        v-model="collapsableFather"
        style="overflow-y:scroll;"
      >
      <!-- Información padre -->
        <div class="container-fluid" style="height:380px;" v-if="collapsableFather">
          <div class="row">
            <div class="col-sm-12">
              <validation-observer ref="observer3" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(savePersonalInfo(2))">
                  <div class="row" id="f10">
                    <div class="col-md-12">
                      <validation-provider
                        name="Tipo de documento"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father13" label="Tipo de documento:" label-for="input-father13" :invalid-feedback="validationContext.errors[0]" >
                          <b-form-select id="input-father13" v-model="formPersonalInfo[2].dadTypeDocument" :options="documentFatherMotherOptions" required
                          :state="getValidationState(validationContext)" :disabled="disabledField"></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f14" v-if="['CC', 'TI'].includes(formPersonalInfo[2].dadTypeDocument)">
                    <div class="col-md-12">
                      <validation-provider
                        name="Fecha de expedición del documento"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father14" label="Fecha de expedición del documento:"
                        label-for="input-father14" :invalid-feedback="validationContext.errors[0]">
                          <b-form-datepicker
                            id="input-father14"
                            v-model="formPersonalInfo[2].dadDocumentIssueDate"
                            type="date"
                            placeholder="Seleecione la fecha de expedición del documento"
                            style="width: 100%"
                            required
                            :state="getValidationState(validationContext)"
                           :disabled="disabledField"
                          ></b-form-datepicker>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f4" v-if="['CC', 'TI'].includes(formPersonalInfo[2].dadTypeDocument)">
                    <div class="col-md-12">
                      <validation-provider
                        name="Ciudad de expedición"
                        :rules="{ required: true, alpha_spaces: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father4" label="Identificación expedida en:" label-for="input-father4"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-father4" v-model="formPersonalInfo[2].dadExpeditionPlace" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la ciudad de expedición del documento" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f5">
                    <div class="col-md-12">
                      <validation-provider
                        name="Correo electrónico"
                        :rules="{ required: true, email: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father5" label="Correo electrónico:" label-for="input-father5"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-father5" v-model="formPersonalInfo[2].dadEmail" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el correo electrónico" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f6">
                    <div class="col-md-12">
                      <validation-provider
                        name="Dirección"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father6" label="Dirección:" label-for="input-father6"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-father6" v-model="formPersonalInfo[2].dadAddress" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la dirección de residencia del padre" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f7">
                    <div class="col-md-12">
                      <validation-provider
                        name="Ciudad"
                        :rules="{ required: true, alpha_spaces: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father7" label="Ciudad:" label-for="input-father7"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-father7" v-model="formPersonalInfo[2].dadCity" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la ciudad de residencia del padre" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f8">
                    <div class="col-md-12">
                      <validation-provider
                        name="Télefono personal"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father8" label="Télefono personal:" label-for="input-father8"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-father8" v-model="formPersonalInfo[2].dadPhone" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el número telefónico" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f9">
                    <div class="col-md-12">
                      <validation-provider
                        name="Ocupación"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father9" label="Ocupación:" label-for="input-father9"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-father9" v-model="formPersonalInfo[2].dadOcupation" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la ocupación del padre" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f10">
                    <div class="col-md-12">
                      <validation-provider
                        name="Trabaja como"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father10" label="Trabaja como:" label-for="input-father10" :invalid-feedback="validationContext.errors[0]" >
                          <b-form-select id="input-father10" v-model="formPersonalInfo[2].dadWorkAs" :options="workAsOptions" required
                          :state="getValidationState(validationContext)" :disabled="disabledField"></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f11">
                    <div class="col-md-12">
                      <validation-provider
                        name="Nombre de la empresa"
                        :rules="rulesWorkAs(2)"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father11" label="Nombre de la empresa donde trabaja:" label-for="input-father11"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-father11" v-model="formPersonalInfo[2].dadCompany" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el nombre de la empresa donde trabaja" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f12">
                    <div class="col-md-12">
                      <validation-provider
                        name="Teléfono de la empresa"
                        :rules="rulesWorkAs(2)"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-father12" label="Teléfono de la empresa:" label-for="input-father12"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-father12" v-model="formPersonalInfo[2].dadCompanyPhone" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese el teléfono de contacto en la empresa" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="f15">
                    <div class="col-md-12">
                        <b-form-group id="input-group-fatherr15">
                          <b-form-checkbox v-model="publishAllowed" :disabled="formPersonalInfo[4].publishAllowed">
                            Autorizo el uso de la imagen de mi hijo para temas publicitarios del colegio.
                          </b-form-checkbox>
                          <small class="ml-4">*Este campo es opcional</small>
                        </b-form-group>
                    </div>
                  </div>
                  <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar cambios</b-button>
                </b-form>
              </validation-observer>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-auto" v-show="formOptionsToFill.guardianWho === '3' && isRoleValid.includes(consts.rolesText.PADRE_MADRE) && isGuardia && this.step >= consts.ENROLLMENT_STEP.DATA">
      <b-row>
        <b-col cols="10" sm="10" md="10" lg="11" class="p-auto">
          <b-button block v-b-toggle="'collapsableGuardian'" variant="link" class="m-auto text-left">
            <!-- <i v-bind:class="[formComplete[3] ? 'fa fa-check-square' : 'fa fa-square-o']" /> -->
            <i class="fa fa-square-o" />
            Información del acudiente
          </b-button>
        </b-col>
        <b-col cols="1" sm="1" md="1" lg="1" class="p-0">
          <b-button block v-b-toggle="'collapsableGuardian'" variant="link" class="m-auto text-left">
            <i :class=" collapsableGuardian ? 'fa fa-angle-double-up text-right' : 'fa fa-angle-double-down text-right'" />
          </b-button>
        </b-col>
      </b-row>
      <b-collapse
        :id="'collapsableGuardian'"
        :accordion="'infoStudent'"
        role="tabpanel"
        v-model="collapsableGuardian"
        style="overflow-y:scroll;"
      >
      <!-- Información guardian -->
        <div class="container-fluid" style="height:380px;" v-if="collapsableGuardian">
          <div class="row">
            <div class="col-sm-12">
              <validation-observer ref="observer4" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(savePersonalInfo(3))">
                  <div class="row" id="g1">
                    <div class="col-md-12">
                      <validation-provider
                        name="Dirección"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-guardian1" label="Dirección:" label-for="input-guardian1"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-guardian1" v-model="formPersonalInfo[3].guardianAddress" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la dirección de residencia del acudiente" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="g2">
                    <div class="col-md-12">
                      <validation-provider
                        name="Ciudad"
                        :rules="{ required: true, alpha_spaces: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-guardian2" label="Ciudad:" label-for="input-guardian2"
                        :invalid-feedback="validationContext.errors[0]">
                          <b-form-input id="input-guardian2" v-model="formPersonalInfo[3].guardianCity" required
                          :state="getValidationState(validationContext)" placeholder="Ingrese la ciudad de residencia del acudiente" :disabled="disabledField"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row" id="g3">
                    <div class="col-md-12">
                      <validation-provider
                        name="Trabaja como"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-guardian3" label="Trabaja como:" label-for="input-guardian3" :invalid-feedback="validationContext.errors[0]" >
                          <b-form-select id="input-guardian3" v-model="formPersonalInfo[3].guardianWorkAs" :options="workAsOptions" required
                          :state="getValidationState(validationContext)" :disabled="disabledField"></b-form-select>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </div>
                  <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar cambios</b-button>
                </b-form>
              </validation-observer>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-auto" v-if="false">
      <b-row>
        <b-col cols="10" sm="10" md="10" lg="11" class="p-auto">
          <b-button block v-b-toggle="'collapsableSignature'" variant="link" class="m-auto text-left">
            <!-- <i v-bind:class="[formComplete[4] ? 'fa fa-check-square' : 'fa fa-square-o']" /> -->
            <i class="fa fa-square-o" />
            Firma digital acudiente
          </b-button>
        </b-col>
        <b-col cols="1" sm="1" md="1" lg="1" class="p-0">
          <b-button block v-b-toggle="'collapsableSignature'" variant="link" class="m-auto text-left">
            <i :class=" collapsableSignature ? 'fa fa-angle-double-up text-right' : 'fa fa-angle-double-down text-right'" />
          </b-button>
        </b-col>
      </b-row>
      <b-collapse
        :id="'collapsableSignature'"
        :accordion="'infoStudent'"
        role="tabpanel"
        v-model="collapsableSignature"
      >
      <!-- Firma digital -->
        <div class="container-fluid" v-if="collapsableSignature">
          <b-form @submit.prevent="handleSubmit(saveSignature())">
            <div class="row">
              <div class="col">
                <MyCanvasComponent @drawing="drawing" :signatureData="signatureData" />
              </div>
            </div>
          </b-form>
        </div>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-auto" v-if="this.step > consts.ENROLLMENT_STEP.DATA">
      <b-row>
        <b-col cols="10" sm="10" md="10" lg="11" class="p-auto">
          <b-button block v-b-toggle="'collapsableSingedFile'" variant="link" class="m-auto text-left">
            <!-- <i v-bind:class="[formComplete[4] ? 'fa fa-check-square' : 'fa fa-square-o']" /> -->
            <i class="fa fa-square-o" />
            Firmar electrónicamente
          </b-button>
        </b-col>
        <b-col cols="1" sm="1" md="1" lg="1" class="p-0">
          <b-button block v-b-toggle="'collapsableSingedFile'" variant="link" class="m-auto text-left">
            <i :class=" collapsableSingedFile ? 'fa fa-angle-double-up text-right' : 'fa fa-angle-double-down text-right'" />
          </b-button>
        </b-col>
      </b-row>
      <b-collapse
        :id="'collapsableSingedFile'"
        :accordion="'infoStudent'"
        role="tabpanel"
        v-model="collapsableSingedFile"
      >
      <div class="d-flex justify-content-end mt-3">
        <b-button variant="primary" class="mr-3" @click="openSignedFile" >Validar identidad</b-button>
      </div>
      <b-row class="mt-4">
        <b-col class="mx-3">
          <b-table v-if="evidencesUser.length > 0" striped hover :fields="columnsEvidences" :items="evidencesUser"
            head-variant="light" responsive>
            <template #cell(templateFile.name)="evidencesUser">
              {{ evidencesUser.item.templateFile.name  }}
              <b-badge variant="success" v-show="evidencesUser.item.signed">Firmado</b-badge>
              <b-badge variant="success" v-show="evidencesUser.item.pathFile && evidencesUser.item.templateFile.type === 'UPLOAD'">Subido</b-badge>
            </template>
            <template #cell(updatedAt)="evidencesUser">
              <div class="d-flex flex-row justify-content-center">
                {{ moment(evidencesUser.item.templateFile.updatedAt).format('YYYY-MM-DD h:mm a')  }}
              </div>
            </template>
            <template #cell(actions)="evidencesUser">
              <div class="d-flex flex-row justify-content-center">
                <b-button variant="primary" class="mr-3" @click="signedFile(evidencesUser.item)" v-show="!evidencesUser.item.signed && isValid && evidencesUser.item.templateFile.type === 'DOWNLOAD'">Firmar</b-button>
                <a-tooltip placement="top" v-if="evidencesUser.item.templateFile.type === 'DOWNLOAD' || evidencesUser.item.pathFile">
                  <template #title>
                    <span>Ver documento</span>
                  </template>
                  <button type="button" @click="downloadEvidence(evidencesUser.item)"
                    class="btn btn-light mr-2">
                    <i class="fa fa-eye text-blue fa-lg" />
                  </button>
                </a-tooltip>
                <a-tooltip placement="top" v-if="evidencesUser.item.templateFile.type === 'UPLOAD'">
                  <template #title>
                    <span>Subir archivo</span>
                  </template>
                  <button type="button" @click="openUploadFile(evidencesUser.item)"
                    class="btn btn-light mr-2">
                    <i class="fa fa-arrow-up" ></i>
                  </button>
                </a-tooltip>
              </div>
            </template>
          </b-table>
          <emptyTable v-else />
        </b-col>
      </b-row>
      <hr class="mx-2" style="border: solid 1.3px #e6e6e6;" v-show="evidence.description && user.role === consts.rolesText.ESTUDIANTE">
      <div v-show="evidence.description && user.role === consts.rolesText.ESTUDIANTE">
        <span class="ml-3">Descripción</span><br>
        <b-row class="mx-2 mt-2">
          <b-col>
            <div v-html="evidence.description"></div>
          </b-col>
        </b-row>
      </div>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-auto" v-if="user.role === consts.rolesText.ESTUDIANTE && this.step === consts.ENROLLMENT_STEP.SUPPORT">
      <b-row>
        <b-col cols="10" sm="10" md="10" lg="11" class="p-auto">
          <b-button block v-b-toggle="'collapsableLoadFile'" variant="link" class="m-auto text-left">
            <!-- <i v-bind:class="[formComplete[4] ? 'fa fa-check-square' : 'fa fa-square-o']" /> -->
            <i class="fa fa-square-o" />
            Subir comprobantes de pago
          </b-button>
        </b-col>
        <b-col cols="1" class="p-0">
          <b-button block v-b-toggle="'collapsableLoadFile'" variant="link" class="m-auto text-left">
            <i :class=" collapsableLoadFile ? 'fa fa-angle-double-up text-right' : 'fa fa-angle-double-down text-right'" />
          </b-button>
        </b-col>
      </b-row>
      <b-collapse
        :id="'collapsableLoadFile'"
        :accordion="'infoStudent'"
        role="tabpanel"
        v-model="collapsableLoadFile"
      >
        <b-row class="mt-4">
        <b-col class="mx-3">
          <b-table v-if="evidencePayment.length > 0" striped hover :fields="columnsEvidences" :items="evidencePayment"
            head-variant="light" responsive>
            <template #cell(updatedAt)="evidencePayment">
              <div class="d-flex flex-row justify-content-center">
                {{ moment(evidencePayment.item.templateFile.updatedAt).format('YYYY-MM-DD h:mm a')  }}
              </div>
            </template>
            <template #cell(actions)="evidencePayment">
              <div class="d-flex flex-row justify-content-center">
                <a-tooltip placement="top" v-if="evidencePayment.item.pathFile">
                  <template #title>
                    <span>Ver documento</span>
                  </template>
                  <button type="button" @click="downloadEvidence(evidencePayment.item)"
                    class="btn btn-light mr-2">
                    <i class="fa fa-eye text-blue fa-lg" />
                  </button>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template #title>
                    <span>Subir archivo</span>
                  </template>
                  <button type="button" @click="openUploadFile(evidencePayment.item)"
                    class="btn btn-light mr-2">
                    <i class="fa fa-arrow-up" ></i>
                  </button>
                </a-tooltip>
              </div>
            </template>
          </b-table>
          <emptyTable v-else />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mx-3">
          Cuando hayas subido el comprobante de pago, el colegio lo revisará y te notificará por correo electrónico sobre la finalización exitosa del proceso del estudiante.
        </b-col>
      </b-row>
      </b-collapse>
    </b-card>
    <b-modal id="signedFile"  ref="modal" title="Validar identidad" hide-footer size="lg" no-close-on-esc no-close-on-backdrop>
      <b-row class="mt-3 mb-3">
        <b-col cols="12">
          <div class="container">
            <div class="d-flex flex-column justify-content-center align-items-center my-3">
              <b-button variant="primary" @click="sendCode()">Enviar código</b-button>
              <small class="text-center mt-1" v-show="generatedCode">El código se ha enviado</small>
              <b-row v-show="generatedCode">Reenviar el código en<span :class="codeTime > 0 ? 'text-primary ml-1': 'text-secondary ml-1'">{{ moment.utc(codeTime * 1000).format("mm:ss") }}</span>
              </b-row>
            </div>
            <p class="text-center">Ingresa el código de 6 dígitos que enviamos a tu correo electrónico</p>
            <b-row class="justify-content-center">
              <span v-for="(code, index) in code" :key="index" class="mx-2" style="min-width: 40px;  min-height: 40px; max-width: 80px;  max-height: 80px;"              >
                  <b-form-input
                  v-model="code.value"
                  type='text'
                  maxlength='1'
                  @input="validateInput(index)"
                  placeholder= '*'
                  :id='`code${index}`'
                  style="min-width: 40px;  min-height: 40px; max-width: 80px;  max-height: 80px; font-size: 2rem;"
                  class="mx-2 mb-2 text-center"
                 :disabled="disabledField"></b-form-input>
                <small v-if="code.error" class="text-danger d-flex justify-items-center">Carácter inválido</small>
              </span>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-button variant="primary" class="float-right mr-3 mb-3" :disabled="isSubmitDisabled" @click="validCode()">Validar</b-button>
      <b-button size="sm" class="float-right mt-1 mr-2 mb-3" @click="closeSignedFile()">Cerrar</b-button>
    </b-modal>
    <b-modal id="uploadFile"  ref="modal" title="Subir documento" hide-footer size="lg" no-close-on-esc no-close-on-backdrop>
      <b-row class="mt-3">
        <b-col cols="12">
          <div class="container">
            <b-row>
              <b-col sm="10" lg="5" class="p-0 mt-2" >
                <span class="text-center">Seleccione el archivo correspondiente a subir.</span>
              </b-col>
              <b-col sm="10" lg="6" class="p-0 mt-1">
                  <b-form-file @change="onFileChange" placeholder="Seleccione un documento"
                    drop-placeholder="Suelta el documento aquí" accept=".pdf, .jpeg, .png" browse-text="Buscar archivo"
                    id="file-updload"></b-form-file>
                  <p class="text-secondary">El documento debe ser en formato .pdf, .jpeg o .png y no debe superar las 5MB</p>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-button variant="primary" class="mr-2 float-right" @click="uploadFile()">Subir</b-button>
      <b-button size="sm" class="float-right mr-2 mt-1" @click="closeUploadFile()">Cerrar</b-button>
    </b-modal>
    <!-- <b-modal id="signed-File"  ref="modal" title="Firma electrónica" hide-footer size="lg" no-close-on-esc no-close-on-backdrop>
      <b-row class="mt-3 mb-3">
        <b-col cols="12">
          <div class="container">
            <b-form-checkbox
              id="checkbox-1"
              v-model="checkReadFiles"
              name="checkbox-1"
              :disabled="checkReadFiles"
            >
              Confirmo que he leído, comprendido y acepto los documentos de matrícula.
            </b-form-checkbox>
          </div>
        </b-col>
      </b-row>
      <b-button variant="primary" class="float-right mr-3 mb-3" :disabled="isSubmitDisabled" @click="signedFile()">Firmar</b-button>
      <b-button size="sm" class="float-right mt-1 mr-2 mb-3" @click="closeSignedFile()">Cerrar</b-button>
    </b-modal> -->
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import MyCanvasComponent from '@/components/custom/signature'
import { mapState } from 'vuex'
import { consts, showErrorMessage } from '@/services/utilities'
import { ToastFire, SwalFire } from '@/services/utilities/swal'
import emptyTable from '@/components/custom/cardEmptyList'
import moment from 'moment'
import store from 'store'

export default {
  components: {
    emptyTable,
    MyCanvasComponent,
  },
  name: 'enrollmentStudent',
  data() {
    return {
      moment,
      enrollmentYear: {},
      evidence: {
        description: '',
      },
      signatureData: {
        state: false,
        path: '',
      },
      enrollmentMsg: {
        state: false,
        firstTime: false,
        title: '',
        body: '',
      },
      notFinished: false,
      form: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: '',
      },
      collapsableStudent: false,
      formComplete: [
        true,
        true,
        true,
        true,
        true,
      ],
      formOptionsToFill: {},
      formPersonalInfo: [{
        nationality: '',
        birthplace: '',
        gender: null,
        birthday: '',
        idType: null,
        expeditionPlace: '',
        bloodType: null,
        eps: '',
        height: '',
        mass: '',
        address: '',
        neighborhood: '',
        city: '',
        stratum: '',
        numberBrother: '',
        stayWithTheLongest: '',
        clinicHistory: '',
        observations: '',
        preferredArea: null,
        areaGreatestDifficulty: null,
        maritalStatus: null,
        /* : '', */
      },
      {
        momExpeditionPlace: '',
        momEmail: '',
        momAddress: '',
        momCity: '',
        momPhone: '',
        momOcupation: '',
        momWorkAs: null,
        momCompany: '',
        momCompanyPhone: '',
        momTypeDocument: null,
        momDocumentIssueDate: null,
      },
      {
        dadExpeditionPlace: '',
        dadEmail: '',
        dadAddress: '',
        dadCity: '',
        dadPhone: '',
        dadOcupation: '',
        dadWorkAs: null,
        dadCompany: '',
        dadCompanyPhone: '',
        dadTypeDocument: null,
        dadDocumentIssueDate: null,
      },
      {
        guardianAddress: '',
        guardianCity: '',
        guardianPhone: '',
        guardianWorkAs: null,
      },
      {
        stepToUpload: '',
        publishAllowed: true,
      },
      ],
      publishAllowed: true,
      collapsableMother: false,
      collapsableFather: false,
      collapsableGuardian: false,
      collapsableSignature: false,
      collapsableSingedFile: false,
      collapsableLoadFile: false,
      genderOptions: [
        { value: null, text: 'Seleccione una opción' },
        { value: 'F', text: 'Mujer' },
        { value: 'M', text: 'Hombre' },
      ],
      documentOptions: [
        { value: null, text: 'Seleccione una opción' },
        { value: 'RCN', text: 'Registro Civil' },
        { value: 'TI', text: 'Tarjeta de Identidad' },
        { value: 'CC', text: 'Cédula de Ciudadanía' },
        { value: 'PASAPORTE', text: 'Pasaporte' },
        'TI', 'CC', 'TE', 'CE', 'PP', 'PEP',
      ],
      documentFatherMotherOptions: [
        { value: null, text: 'Seleccione una opción' },
        { value: 'TI', text: 'Tarjeta de Identidad' },
        { value: 'TE', text: 'Tarjeta de extranjería' },
        { value: 'CC', text: 'Cédula de Ciudadanía' },
        { value: 'CE', text: 'Cédula de extranjería' },
        { value: 'PP', text: 'Pasaporte' },
        { value: 'PEP', text: 'Permiso especial de permanencia' },
      ],
      bloodOptions: [
        { value: null, text: 'Seleccione una opción' },
        { value: 'O+', text: 'O+' },
        { value: 'O-', text: 'O-' },
        { value: 'A+', text: 'A+' },
        { value: 'A-', text: 'A-' },
        { value: 'B+', text: 'B+' },
        { value: 'B-', text: 'B-' },
        { value: 'AB+', text: 'AB+' },
        { value: 'AB-', text: 'AB-' },
      ],
      areaOptions: [
        { value: null, text: 'Seleccione una opción' },
        { value: 'CIENCIAS', text: 'Ciencias' },
        { value: 'DANZAS', text: 'Danzas' },
        { value: 'MUSICA', text: 'Música' },
        { value: 'ETICA', text: 'Ética' },
        { value: 'EDUFISICA', text: 'Educación Física' },
        { value: 'FISICA', text: 'Física' },
        { value: 'MATEMATICAS', text: 'Matemáticas' },
        { value: 'TECNOLOGIA', text: 'Tecnología' },
        { value: 'ESPAÑOL', text: 'Español' },
        { value: 'INGLES', text: 'Inglés' },
        { value: 'SOCIALES', text: 'Sociales' },
        { value: 'FILOSOFIA', text: 'Filosofía' },
        { value: 'QUIMICA', text: 'Química' },
        { value: 'INGENIERIA', text: 'Ingeniería' },
      ],
      maritalOptions: [
        { value: null, text: 'Seleccione una opción' },
        { value: 'SOLTEROS', text: 'Solteros' },
        { value: 'CASADOS', text: 'Casados' },
        { value: 'UNIONLIBRE', text: 'Unión libre' },
        { value: 'DIVORCIADOS', text: 'Divorciados' },
        { value: 'VIUDO', text: 'Viudo' },
      ],
      workAsOptions: [
        { value: null, text: 'Seleccione una opción' },
        { value: '1', text: 'Empleado' },
        { value: '2', text: 'Independiente' },
        { value: '3', text: 'No aplica' },
      ],
      img: '',
      consts,
      formFile: {
        file: null,
      },
      paymentReceipt: null,
      code: [
        { value: '', error: false },
        { value: '', error: false },
        { value: '', error: false },
        { value: '', error: false },
        { value: '', error: false },
        { value: '', error: false },
      ],
      evidencesUser: [],
      // deben ser cargadas según la instituci: y unidas a las que debe entregar el estudiante
      evidences: [],
      // Datos de la columna
      columnsEvidences: [
        { label: 'Código', key: 'id' },
        { label: 'Documento', key: 'templateFile.name' },
        { label: 'Fecha', key: 'updatedAt' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      isFather: false,
      isMother: false,
      isGuardia: false,
      descriptionLoad: '<p><span style="color: rgb(0, 0, 0);">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin non molestie risus, a venenatis velit. Vivamus non aliquam urna. Ut ornare nibh at justo placerat elementum. Aenean commodo mi quis varius iaculis. Donec accumsan, mi ac sollicitudin fermentum, lacus est accumsan nisi, et tempor tortor elit eget nibh. Donec eget sapien sed massa posuere fringilla a quis mauris. Nullam eu turpis fringilla, pharetra ante in, consequat mauris. In pretium tincidunt metus.</span></p><p><br></p><p>Enlaces </p><ul><li><a href="https://www.w3schools.com/html/tryit.asp?filename=tryhtml_links_w3schools" rel="noopener noreferrer" target="_blank" style="color: rgb(255, 255, 255); background-color: rgb(76, 175, 80);">Try it Yourself </a></li><li><a href="https://www.w3schools.com/html/tryit.asp?filename=tryhtml_links_w3schools" rel="noopener noreferrer" target="_blank" style="color: rgb(255, 255, 255); background-color: rgb(76, 175, 80);">Try it Yourself </a></li><li><a href="https://www.w3schools.com/html/tryit.asp?filename=tryhtml_links_w3schools" rel="noopener noreferrer" target="_blank" style="color: rgb(255, 255, 255); background-color: rgb(76, 175, 80);">Try it Yourself </a></li></ul>',
      signedFiles: false,
      checkReadFiles: false,
      generatedCode: false,
      codeTime: 0,
      codeSigned: 0,
      timerInterval: null,
      timerIntervalSigned: null,
      isRoleValid: [],
      state: '',
      step: '',
      evidencesStudent: [],
      evidencePayment: [],
      isValid: false,
      children: [],
      hasChildren: false,
      selectedChild: null,
      disabledField: false,
      firstLoad: false,
    }
  },
  created: function () {
    const userData = JSON.parse(store.get('userData'))
    this.isRoleValid = userData.roles
  },
  mounted: async function () {
    const userData = JSON.parse(store.get('userData'))
    if (this.isRoleValid.includes(consts.rolesText.ESTUDIANTE)) {
      await this.getStudentInfo(userData.id)
    } else if (this.isRoleValid.includes(consts.rolesText.PADRE_MADRE)) {
      await this.getChildrenData(userData.id)
        .then(async () => await this.getStudentInfo(this.selectedChild))
    }
    if (this.step >= consts.ENROLLMENT_STEP.SIGN) {
      this.getEnrollmentYear()
        .then(() => this.getEvidence())
        .then(() => this.getTemplateFiles(this.step))
    } else {
      this.getEnrollmentYear()
        .then(() => this.getEvidence())
    }
  },
  updated: function () {
  },
  beforeDestroy: function () {
  },
  watch: {
    selectedChild: async function () {
      if (!this.firstLoad) {
        await this.refreshData()
      } else {
        this.firstLoad = false
      }
    },
  },
  computed: {
    ...mapState(['user']),
    isSubmitDisabled() {
      return this.code.some(element => element.error || element.value === '')
    },
    codeValidation() {
      return this.code.map(element => element.value).join('')
    },
  },
  methods: {
    validateInput(index) {
      const value = String(this.code[index].value).trim()
      if ((!/^\d$/.test(value))) {
        this.code[index].error = true
      } else {
        this.code[index].error = false
        if ((index + 1) < this.code.length) {
          document.getElementById(`code${index + 1}`).focus()
        }
      }
    },
    rulesWorkAs(value) {
      const whoString = ['mom', 'dad', 'guardian']
      if (this.formPersonalInfo[value][whoString[value - 1] + 'WorkAs'] === '1') {
        return { required: true }
      } else {
        return { required: false }
      }
    },
    async getChildrenData(idParent) {
      await apiClient.get(`/users/check-children/${idParent}`).then(response => {
        this.hasChildren = response.data.length > 0
        if (this.hasChildren) {
          this.children = response.data.map(x => {
            return {
              value: x.idChild,
              text: x.fullName,
            }
          })
          this.selectedChild = this.children[0].value
          this.firstLoad = true
        }
      })
    },
    async getStudentInfo(idStudent) {
      await apiClient.get(`/enrollments/enroll-student/${idStudent}`).then(async (response) => {
        await this.setStudentInfo(null, response)
        this.disabledField = (this.step === consts.ENROLLMENT_STEP.SUPPORT || this.state === consts.ENROLLMENT_STATE.MATRICULATE) || false
      }).catch(error => {
        ToastFire('warning', showErrorMessage(error))
        this.step = 0
      })
    },
    setStudentInfo (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
        this.isStudent = false
      } else {
        this.isStudent = true
        if (data !== null) {
          this.collapsableMother = false
          this.collapsableFather = false
          this.collapsableGuardian = false
          this.formPersonalInfo[0] = data.data[0]
          this.formOptionsToFill = data.data[4]
          delete this.formPersonalInfo[0].clinicHistory
          delete this.formPersonalInfo[0].observations
          for (const key in this.formPersonalInfo[0]) {
            if (this.formPersonalInfo[0][key] === null || this.formPersonalInfo[0][key].length < 1) {
              this.formComplete[0] = false
              this.formComplete = [...this.formComplete]
            }
          }
          this.formPersonalInfo[0] = data.data[0]
          this.formPersonalInfo[1] = data.data[1]
          if (this.formOptionsToFill.momLives === 'SI') {
            const momKeys = Object.keys(this.formPersonalInfo[1])
            this.isMother = this.formPersonalInfo[1].momCC === this.user.nip
            for (let i = 0; i < momKeys.length; i++) {
              if (this.formPersonalInfo[1][momKeys[i]] === null || this.formPersonalInfo[1][momKeys[i]].length < 1) {
                if (momKeys[i] === 'momCompany' && (this.formPersonalInfo[1].momWorkAs === '2' || this.formPersonalInfo[1].momWorkAs === '3')) {
                  i = i + 2
                } else if (momKeys[i] === 'momDocumentIssueDate' && (!['CC', 'TI'].includes(this.formPersonalInfo[1].momTypeDocument))) {
                  i += 1
                } else {
                  this.formComplete[1] = false
                  this.formComplete = [...this.formComplete]
                }
              }
            }
          } else {
            this.formComplete[1] = true
            this.formComplete = [...this.formComplete]
          }
          this.formPersonalInfo[2] = data.data[2]
          if (this.formOptionsToFill.dadLives === 'SI') {
            const dadKeys = Object.keys(this.formPersonalInfo[2])
            this.isFather = this.formPersonalInfo[2].dadCC === this.user.nip
            for (let i = 0; i < dadKeys.length; i++) {
              if (this.formPersonalInfo[2][dadKeys[i]] === null || this.formPersonalInfo[2][dadKeys[i]].length < 1) {
                if (dadKeys[i] === 'dadCompany' && (this.formPersonalInfo[2].dadWorkAs === '2' || this.formPersonalInfo[2].dadWorkAs === '3')) {
                  i = i + 2
                } else if (dadKeys[i] === 'dadDocumentIssueDate' && (!['CC', 'TI'].includes(this.formPersonalInfo[2].dadTypeDocument))) {
                  i += 1
                } else {
                  this.formComplete[2] = false
                  this.formComplete = [...this.formComplete]
                }
              }
            }
          } else {
            this.formComplete[2] = true
            this.formComplete = [...this.formComplete]
          }
          this.formPersonalInfo[3] = data.data[3]
          if (this.formOptionsToFill.guardianWho === '3') {
            this.isGuardia = this.formPersonalInfo[3].guardianCC === this.user.nip
            for (const key in this.formPersonalInfo[3]) {
              if (this.formPersonalInfo[3][key] === null || this.formPersonalInfo[3][key].length < 1) {
                this.formComplete[3] = false
                this.formComplete = [...this.formComplete]
              }
            }
          } else {
            this.formComplete[3] = true
            this.formComplete = [...this.formComplete]
          }
          this.enrollmentMsg = data.data[4].enrollmentMsg
          this.step = data.data[4].step
          this.state = data.data[4].state
          this.formPersonalInfo[4].publishAllowed = true
          if (data.data[4].phone !== undefined) {
            this.formPersonalInfo[4].phone = data.data[4].phone
          }
          this.formComplete[4] = this.signatureData.state = (data.data[5].guardianSignature !== null)
          if (this.signatureData.state) {
            this.signatureData.path = data.data[5].guardianSignature
          }
          for (let i = 0; i < this.formPersonalInfo.length; i++) {
            this.formPersonalInfo[i] = { ...this.formPersonalInfo[i] }
          }
        }
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    async savePersonalInfo(stepToUpload) {
      if ((this.step === consts.ENROLLMENT_STEP.SUPPORT || this.state === consts.ENROLLMENT_STATE.MATRICULATE)) {
        ToastFire('warning', 'Por favor comunícate con la institución educativa para efectuar cambios en la información.')
        return
      }
      let isValid = true
      this.formPersonalInfo[4].stepToUpload = stepToUpload
      switch (stepToUpload) {
        case 0:
          if (!(await this.$refs.observer1.validate())) {
            isValid = false
          }
          stepToUpload = 'del estudiante'
          this.formComplete[0] = true
          this.formComplete = [...this.formComplete]
          break
        case 1:
          if (!(await this.$refs.observer2.validate())) {
            isValid = false
          }
          stepToUpload = 'de la madre'
          this.formComplete[1] = true
          this.formComplete = [...this.formComplete]
          break
        case 2:
          if (!(await this.$refs.observer3.validate())) {
            isValid = false
          }
          stepToUpload = 'del padre'
          this.formComplete[2] = true
          this.formComplete = [...this.formComplete]
          break
        case 3:
          if (!(await this.$refs.observer4.validate())) {
            isValid = false
          }
          stepToUpload = 'del acudiente'
          this.formComplete[3] = true
          this.formComplete = [...this.formComplete]
          break
      }
      if (!isValid) {
        this.$notification.error({
          message: `Verifique que los campos ${stepToUpload} esten diligenciados correctamente`,
        })
      } else {
        this.formPersonalInfo[4].publishAllowed = true
        this.formPersonalInfo[4].formComplete = this.formComplete
        apiClient.patch(`/enrollments/${this.$store.state.user.id}`, this.formPersonalInfo).then(response => {
          // Paso a actualizar
          this.$notification.success({
            message: `Información ${stepToUpload} guardada correctamente`,
          })
        }).catch(error => {
          this.$notification.error({
            message: 'Ooops ocurrio un error',
            description: showErrorMessage(error),
          })
        })
      }
    },
    saveSignature() {
      if (this.img.length > 1) {
        apiClient.patch('/enrollments/' + this.$store.state.user.id + '/signature', { data: this.img }).then(response => {
          Swal.fire('', 'Firma actualizada correctamente', 'success')
          this.formComplete[4] = true
          this.refreshData()
        }).catch(error => {
          Swal.fire('', showErrorMessage(error), 'warning')
        })
      } else {
        Swal.fire('', 'Por favor ingrese su firma y luego haga click en el botón guardar', 'warning')
      }
    },
    async refreshData() {
      const userData = JSON.parse(store.get('userData'))
      if (this.isRoleValid.includes(consts.rolesText.ESTUDIANTE)) {
        await this.getStudentInfo(userData.id)
      } else if (this.isRoleValid.includes(consts.rolesText.PADRE_MADRE)) {
        await this.getStudentInfo(this.selectedChild)
      }
      if (this.step >= consts.ENROLLMENT_STEP.SIGN) {
        this.getEnrollmentYear()
          .then(() => this.getEvidence())
          .then(() => this.getTemplateFiles(this.step))
      } else {
        this.getEnrollmentYear()
          .then(() => this.getEvidence())
      }
    },
    drawing(img) {
      this.img = img
      this.saveSignature()
    },
    checkForms() {
      for (let i = 0; i < this.formComplete.length; i++) {
        if (!this.formComplete[i]) {
          return 'Existen campos vacíos en el formulario, para continuar con el proceso es necesario contestar todas las preguntas y tener diligenciada la firma digital del acudiente.'
        }
      }
      return this.enrollmentMsg.body
    },
    onFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        const allowedTypes = [
          'application/pdf',
          'image/jpeg',
          'image/png',
        ]
        if (!allowedTypes.includes(e.target.files[0].type)) {
          this.formFile.file = null
          e.target.value = null
          ToastFire('warning', 'Por favor, seleccione un archivo pdf, imagen (.jpeg, .png)')
        } else if (e.target.files[0].size > 5000000) {
          ToastFire('warning', 'El archivo tiene ' + ((e.target.files[0].size / 1000000)).toFixed() + 'MB y no puede superar las 5MB')
          e.target.value = null
        } else {
          this.formFile.file = file
        }
      }
    },
    signedFile(item) {
      apiClient2.post(`enrollments/enrollment-templates/${this.enrollmentYear.idEvidence}/file/${item.id}`).then(response => {
        const responseSwal = SwalFire('Mensaje de confirmación', ('El documento ha sido firmado. Para descargar los documentos firmados, es necesario que todos los involucrados hayan completado la firma electrónica.'), 'success', 'cerrar', false)
        if (responseSwal) {
          this.$bvModal.hide('signedFile')
          // recorrer las evidencias
          for (let i = 0; i < this.evidencesUser.length; i++) {
            if (this.evidencesUser[i].id === item.id) {
              this.evidencesUser[i].signed = true
            }
          }
        }
      }).catch(error => {
        this.$bvModal.hide('signedFile')
        ToastFire('warning', `${showErrorMessage(error)}`)
      })
    },
    openSignedFile(item) {
      this.formFile.file = item.file
      this.code.map((element) => {
        element.value = ''
        element.error = false
      })
      // this.sendCode()
      this.$bvModal.show('signedFile')
    },
    closeSignedFile() {
      this.$bvModal.hide('signedFile')
      this.formFile = {
        file: null,
      }
    },
    uploadFile() {
      const formData = new FormData()
      if (this.formFile.file !== null) {
        formData.append('file', this.formFile.file)
      }
      formData.append('form', JSON.stringify({ idEvidence: this.enrollmentYear.idEvidence }))
      apiClient2.post(`enrollments/enrollment-templates/${this.formFile.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(response => {
        for (let i = 0; i < this.evidencesUser.length; i++) {
          if (this.evidencesUser[i].id === this.formFile.id) {
            this.evidencesUser[i].pathFile = response.data.data.Location
          }
        }
        for (let i = 0; i < this.evidencePayment.length; i++) {
          if (this.evidencePayment[i].id === this.formFile.id) {
            this.evidencePayment[i].pathFile = response.data.data.Location
          }
        }
        ToastFire('success', 'Documento subido exitosamente')
      }).catch(error => {
        ToastFire('warning', `${showErrorMessage(error)}`)
      })
      this.$bvModal.hide('uploadFile')
    },
    openUploadFile(item) {
      this.formFile = item
      this.$bvModal.show('uploadFile')
    },
    closeUploadFile() {
      this.formFile.file = null
      this.$bvModal.hide('uploadFile')
    },
    async getEnrollmentYear() {
      await apiClient2.get('enrollments/enrollment-year').then(response => {
        this.enrollmentYear = response.data.data
      }).catch(error => {
        ToastFire('warning', `${showErrorMessage(error)}`)
      })
    },
    async getEvidence() {
      await apiClient2.get(`evidences/${this.enrollmentYear.idEvidence}`).then(response => {
        this.evidence = response.data.data
      }).catch(error => {
        ToastFire('warning', `${showErrorMessage(error)}`)
      })
    },
    getTemplateFiles (step) {
      const userData = JSON.parse(store.get('userData'))
      const sentParams = {
        step,
        ...(this.hasChildren && { idChild: this.selectedChild }),
      }
      apiClient2.get(`enrollments/enrollment-templates/${this.enrollmentYear.idEvidence}/user/${userData.id}`, { params: sentParams }).then(response => {
        this.evidencesUser = []
        this.evidencePayment = []
        const idFiles = []
        for (const data of response.data.data) {
          if (data.idUser === userData.id) {
            if (this.isRoleValid.includes(consts.rolesText.ESTUDIANTE)) {
              if (data.templateFile.step === consts.ENROLLMENT_STEP.SIGN && data.templateFile.binded !== '2' && !idFiles.includes(data.templateFile.id)) {
                data.readAndAccept = false
                this.evidencesUser.push(data)
                idFiles.push(data.templateFile.id)
              } else if (data.templateFile.step === consts.ENROLLMENT_STEP.SUPPORT) {
                this.evidencePayment.push(data)
              }
            } else if (this.isRoleValid.includes(consts.rolesText.PADRE_MADRE)) {
              if (data.templateFile.step === consts.ENROLLMENT_STEP.SIGN && data.templateFile.binded !== '1') {
                data.readAndAccept = false
                this.evidencesUser.push(data)
              } else if (data.templateFile.step === consts.ENROLLMENT_STEP.SUPPORT) {
                this.evidencePayment.push(data)
              }
            }
          }
        }
      }).catch(error => {
        ToastFire('warning', `${showErrorMessage(error)}`)
      })
    },
    downloadEvidence(item) {
      if (item.templateFile.type === 'DOWNLOAD') {
        apiClient2.get(`enrollments/enrollment-templates/${item.id}/preview`).then(response => {
          if (response.data.data.type !== 'URL') {
            //
            const { url, type } = response.data.data
            const blob = new Blob([Uint8Array.from(atob(url), c => c.charCodeAt(0))], { type })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `${item.templateFile.name}.docx`
            link.click()
          } else {
            window.open(response.data.data.url, '_blank')
          }
        }).catch(error => {
          ToastFire('warning', `${showErrorMessage(error)}`)
        })
      } else {
        apiClient2.get(`enrollments/enrollment-templates/uploaded-file/${item.id}`).then(response => {
          window.open(response.data.data, '_blank')
        }).catch(error => {
          ToastFire('warning', `${showErrorMessage(error)}`)
        })
      }
    },
    removeEvidence(item) {
      this.evidencesUser = this.evidencesUser.filter((element) => {
        if (element.id !== item.id) {
          return element
        } else {
          element.file = null
          return element
        }
      })
      ToastFire('success', 'Documento removido con exito')
    },
    sendCode() {
      const userData = JSON.parse(store.get('userData'))
      apiClient2.post(`enrollments/enrollment-templates/${this.enrollmentYear.idEvidence}/user/${userData.id}/get-code`).then(response => {
        ToastFire('success', 'Código enviado')
      }).catch((error) => {
        ToastFire('warning', `${showErrorMessage(error)}`)
      })
    },
    startTemp() {
      this.timerInterval = setInterval(() => {
        this.codeTime--
        if (this.codeTime <= 0) {
          clearInterval(this.timerInterval)
          localStorage.removeItem('timerStart')
          this.generatedCode = false
        }
      }, 1000)
    },
    // timeSig
    startSigned() {
      this.timerInterval = setInterval(() => {
        this.codeSigned--
        if (this.codeSigned <= 0) {
          clearInterval(this.timerInterval)
          localStorage.removeItem('timerSigned')
        }
      }, 1000)
    },
    validCode() {
      const userData = JSON.parse(store.get('userData'))
      apiClient2.post(`enrollments/enrollment-templates/${this.enrollmentYear.idEvidence}/user/${userData.id}/check-code`, { code: parseInt(this.codeValidation, 10) }).then(response => {
        const responseSwal = SwalFire('Mensaje de confirmación', ('Identidad válida.'), 'success', 'cerrar', false)
        if (responseSwal) {
          this.$bvModal.hide('signedFile')
          this.isValid = true
        }
        this.isValid = true
      }).catch(error => {
        this.$bvModal.hide('signedFile')
        ToastFire('warning', `${showErrorMessage(error)}`)
      })
    },
  },
}
</script>
